import { StyledWizardField } from 'components/Wizards/shared/styles';
import KizenTypography from 'app/kizentypo';
import Input from 'components/Kizen/Input';
import { useTranslation } from 'react-i18next';
import { getDataQAForInput } from 'components/Inputs/helpers';

const TitleField = ({
  defaultName = '',
  name = '',
  onChangeName,
  top = 10,
  entityName,
  flex,
  inputTop = 6,
}) => {
  const { t } = useTranslation();

  return (
    <StyledWizardField top={top} flex={flex}>
      <KizenTypography type="subheader">
        {t('Name Your {{entityName}}', { entityName })}
      </KizenTypography>
      <StyledWizardField top={inputTop} flex={flex}>
        <Input
          placeholder={defaultName}
          value={name}
          onChange={onChangeName}
          {...getDataQAForInput('dashlet-name')}
        />
      </StyledWizardField>
    </StyledWizardField>
  );
};

export default TitleField;
